export default "__VITE_ASSET__6a489688__"